<template>
  <div class="notice-container">
    <el-card shadow="hover">
      <template #header>
        <div class="header-row">
          <div class="header-left">
            <h3 class="page-title">游戏公告配置</h3>
            <span class="page-desc">全局公告 · 所有区服共用配置</span>
          </div>
          <div class="btn-group">
            <el-button type="primary" @click="loadNotice" :loading="loadingGet" icon="Refresh">读取配置</el-button>
            <el-button type="success" @click="saveNotice" :loading="loadingSave" icon="Check">保存配置</el-button>
            <el-button type="info" @click="addItem" icon="Plus">新增公告模块</el-button>
          </div>
        </div>
      </template>

      <!-- ========== 公告总标题区域 ========== -->
      <div class="block-wrap">
        <h4 class="block-title">📌 公告总标题</h4>
        <el-form label-width="110px">
          <el-form-item label="标题文字">
            <el-input
              v-model="mainTitle.Text"
              placeholder="请输入公告大标题，例如：本周活动公告"
              clearable
            />
          </el-form-item>

          <!-- 样式设置区域（灰色背景区分） -->
          <div class="style-set-wrap">
            <el-form-item label="字体样式">
              <el-select v-model="mainTitle.FontFamily" placeholder="字体" style="width:180px">
                <el-option label="默认黑体" value="SimHei"></el-option>
                <el-option label="微软雅黑" value="Microsoft YaHei"></el-option>
                <el-option label="宋体" value="SimSun"></el-option>
                <el-option label="Arial" value="Arial"></el-option>
              </el-select>
              <el-select v-model="mainTitle.FontSize" placeholder="字号" style="width:120px">
                <el-option label="12px" value="12"></el-option>
                <el-option label="14px" value="14"></el-option>
                <el-option label="16px" value="16"></el-option>
                <el-option label="18px" value="18"></el-option>
                <el-option label="20px" value="20"></el-option>
                <el-option label="24px" value="24"></el-option>
                <el-option label="28px" value="28"></el-option>
                <el-option label="32px" value="32"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>

        <!-- 预览区域 -->
        <div
          class="preview-block"
          :style="{
            fontFamily: mainTitle.FontFamily,
            fontSize: mainTitle.FontSize + 'px'
          }"
        >
          <div class="preview-label">👁️ 总标题实时预览</div>
          <div class="preview-text">{{ mainTitle.Text || '（暂无文字）' }}</div>
        </div>
      </div>

      <el-divider content-position="left">公告模块列表</el-divider>

      <!-- ========== 多条公告模块 ========== -->
      <div class="notice-list">
        <div
          class="notice-item"
          v-for="(item, idx) in noticeList"
          :key="`notice_${idx}`"
        >
          <div class="item-head">
            <el-tag type="info" size="large">模块{{ idx + 1 }}</el-tag>
            <el-button
              type="danger"
              size="small"
              icon="Delete"
              @click="delItem(idx)"
              :disabled="noticeList.length <= 1"
            >删除模块</el-button>
          </div>

          <!-- 小标题区域 -->
          <div class="block-wrap">
            <h5 class="block-subtitle">🔹 小标题</h5>
            <el-form label-width="100px">
              <el-form-item label="文字内容">
                <el-input
                  v-model="item.Title.Text"
                  placeholder="输入小标题，例如：限时活动"
                  clearable
                />
              </el-form-item>
              <div class="style-set-wrap">
                <el-form-item label="字体样式">
                  <el-select v-model="item.Title.FontFamily" placeholder="字体" style="width:180px">
                    <el-option label="默认黑体" value="SimHei"></el-option>
                    <el-option label="微软雅黑" value="Microsoft YaHei"></el-option>
                    <el-option label="宋体" value="SimSun"></el-option>
                    <el-option label="Arial" value="Arial"></el-option>
                  </el-select>
                  <el-select v-model="item.Title.FontSize" placeholder="字号" style="width:120px">
                    <el-option label="12px" value="12"></el-option>
                    <el-option label="14px" value="14"></el-option>
                    <el-option label="16px" value="16"></el-option>
                    <el-option label="18px" value="18"></el-option>
                    <el-option label="20px" value="20"></el-option>
                    <el-option label="24px" value="24"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-form>
            <div
              class="preview-block"
              :style="{
                fontFamily: item.Title.FontFamily,
                fontSize: item.Title.FontSize + 'px'
              }"
            >
              <div class="preview-label">👁️ 小标题预览</div>
              <div class="preview-text">{{ item.Title.Text || '（暂无文字）' }}</div>
            </div>
          </div>

          <!-- 正文区域 -->
          <div class="block-wrap">
            <h5 class="block-subtitle">🔹 公告正文</h5>
            <el-form label-width="100px">
              <el-form-item label="文字内容">
                <el-input
                  v-model="item.Content.Text"
                  type="textarea"
                  :rows="7"
                  placeholder="请输入公告内容，支持回车换行"
                  resize="none"
                />
              </el-form-item>
              <div class="style-set-wrap">
                <el-form-item label="字体样式">
                  <el-select v-model="item.Content.FontFamily" placeholder="字体" style="width:180px">
                    <el-option label="默认黑体" value="SimHei"></el-option>
                    <el-option label="微软雅黑" value="Microsoft YaHei"></el-option>
                    <el-option label="宋体" value="SimSun"></el-option>
                    <el-option label="Arial" value="Arial"></el-option>
                  </el-select>
                  <el-select v-model="item.Content.FontSize" placeholder="字号" style="width:120px">
                    <el-option label="12px" value="12"></el-option>
                    <el-option label="14px" value="14"></el-option>
                    <el-option label="16px" value="16"></el-option>
                    <el-option label="18px" value="18"></el-option>
                    <el-option label="20px" value="20"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-form>
            <div
              class="preview-block"
              :style="{
                fontFamily: item.Content.FontFamily,
                fontSize: item.Content.FontSize + 'px'
              }"
            >
              <div class="preview-label">👁️ 正文预览</div>
              <div class="preview-text" v-html="formatText(item.Content.Text)"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="tip-wrap">
        <el-icon color="#409eff"><InfoFilled /></el-icon>
        <span class="tip-text">文字输入区为白色背景；字体/字号设置区域为浅灰色；底部虚线框为实时预览区域。保存后所有样式同步下发游戏客户端。至少保留1个公告模块。</span>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { ElMessage, ElIcon, InfoFilled } from 'element-plus'
import axios from 'axios'

const baseApi = 'https://log.wuxiahaojie.com/api/notice'

const loadingGet = ref(false)
const loadingSave = ref(false)

// 与后端模型一一对应
const mainTitle = ref({
  Text: '',
  FontFamily: 'SimHei',
  FontSize: '24'
})

const noticeList = ref([
  {
    Title: { Text: '', FontFamily: 'SimHei', FontSize: '20' },
    Content: { Text: '', FontFamily: 'SimHei', FontSize: '16' }
  }
])

// 换行转br预览
function formatText(text) {
  if (!text) return ''
  return text.replace(/\n/g, '<br/>')
}

// 新增模块
function addItem() {
  noticeList.value.push({
    Title: { Text: '', FontFamily: 'SimHei', FontSize: '20' },
    Content: { Text: '', FontFamily: 'SimHei', FontSize: '16' }
  })
}

// 删除模块
function delItem(index) {
  if (noticeList.value.length <= 1) {
    ElMessage.warning('至少保留一个公告模块')
    return
  }
  noticeList.value.splice(index, 1)
}

// 读取配置
async function loadNotice() {
  if (loadingGet.value) return
  loadingGet.value = true
  try {
    const res = await axios.get(`${baseApi}/getNotice`)
    if (res.data.code === 200) {
      const data = res.data.data
      mainTitle.value = data.MainTitle
      noticeList.value = data.List
      ElMessage.success('读取公告配置成功')
    } else {
      ElMessage.warning(res.data.msg || '读取配置失败')
    }
  } catch (err) {
    console.error(err)
    ElMessage.error(`读取失败：${err.message || '网络异常'}`)
  } finally {
    loadingGet.value = false
  }
}

// 保存配置
async function saveNotice() {
  if (loadingSave.value) return

  if (!mainTitle.value.Text.trim()) {
    ElMessage.warning('请填写公告总标题')
    return
  }
  for (let i = 0; i < noticeList.value.length; i++) {
    const item = noticeList.value[i]
    if (!item.Title.Text?.trim()) {
      ElMessage.warning(`第${i + 1}个模块，请填写小标题`)
      return
    }
    if (!item.Content.Text?.trim()) {
      ElMessage.warning(`第${i + 1}个模块，请填写公告内容`)
      return
    }
  }

  loadingSave.value = true
  try {
    const payload = {
      MainTitle: mainTitle.value,
      List: noticeList.value
    }
    const token = sessionStorage.getItem('token')
    const res = await axios.post(`${baseApi}/saveNotice`, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    if (res.data.code === 200) {
      ElMessage.success('公告配置保存成功，全局生效')
    } else {
      ElMessage.warning(res.data.msg || '保存配置失败')
    }
  } catch (err) {
    console.error(err)
    ElMessage.error(`保存失败：${err.message || '网络异常'}`)
  } finally {
    loadingSave.value = false
  }
}
</script>

<style scoped>
.notice-container {
  padding: 16px;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
}

.header-left {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.page-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2329;
}

.page-desc {
  font-size: 13px;
  color: #86909c;
}

.btn-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.block-wrap {
  padding: 14px;
  border-radius: 8px;
  background-color: #fcfcfd;
  border: 1px solid #e8e8eb;
  margin-bottom: 16px;
}

.block-title {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
  color: #252a34;
}

.block-subtitle {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 500;
  color: #374151;
}

/* 样式设置区域：灰色底色，和输入框区分开！核心区分样式 */
.style-set-wrap {
  background-color: #f3f4f6;
  padding: 10px 12px;
  border-radius: 6px;
  margin: 8px 0;
}

.notice-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 12px;
}

.notice-item {
  border: 1px solid #e5e6eb;
  border-radius: 10px;
  padding: 20px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.item-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

/* 预览区域 */
.preview-block {
  margin-top: 10px;
  padding: 14px;
  background: #f7f8fa;
  border-radius: 6px;
  border: 1px dashed #cdd0d6;
}
.preview-label {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 8px;
}
.preview-text {
  color: #111827;
  line-height: 1.6;
}

.tip-wrap {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 20px;
  padding: 12px;
  background-color: #f0f7ff;
  border-radius: 6px;
}
.tip-text {
  font-size: 13px;
  color: #4e5969;
  line-height: 1.6;
}
</style>
